<template>
    <div class="">
        <div class="page">
            <div class="page__title">{{ title }}</div>
        </div>

        <div @click="backUrl ? $router.push(backUrl) : $router.go(-1)" class="page__nav">
            <div class="page__nav__icon">
                <svg fill="none" height="16" viewBox="0 0 19 16" width="19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z" fill="#655D79" />
                </svg>
            </div>
            <div class="page__nav__text">{{ subTitle }}</div>
        </div>

        <div class="details" v-if="!hide">
            <div class="details__card">
                <div class="details__card__container">
                    <div class="details__card__header">Details</div>
                    <div class="details__card__item" v-for="(detail, index) in details" :key="index" >
                        <div  v-for="(value, propertyName, index) in detail" :key="index">
                            <div class="details__card__item__label" :class="index === 0 ? 'left': 'right'">{{ propertyName }}</div>
                            <div class="details__card__item__value" :class="index === 0 ? 'left': 'right'">{{ value }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <SubDetail :subDetailTitle="subDetailTitle" :subDetailContents="subDetailContents" />
        </div>
    </div>
</template>
<script>
import SubDetail from '@/components/subdetail.vue'; 

export default {
    name: 'DetailCard',
    props: {
        details: Array,
        title: String,
        subTitle: String,
        subDetailTitle: String,
        subDetailContents: Object,
        backUrl: String,
        hide: Boolean
    },
    components: {
        SubDetail
    }
}
</script>
<style lang="scss" scoped>
.right {
    text-align: right;
}

.page, .page__nav, .details {
   margin: 30px;
}

.details__card {
  width: 50%;
}

.sub-details   {
    width: 50%;
}
</style>